import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';
import ImageInfo from '~/components/InfoTooltip/ImageInfo';

import { Image3D } from '~/domain/patient/image3d';

type ImageTitleProps = {
    label: string | ReactNode;
    image: Image3D;
};

export default function ImageTitle({ label, image }: ImageTitleProps) {
    return (
        <Box
            display="flex"
            gap={0.5}
            alignItems="center"
            sx={(theme) => ({
                color: theme.palette.primary.main,
            })}
        >
            <Typography fontSize={12} color="primary">
                {label}
            </Typography>
            <ImageInfo image={image} />
        </Box>
    );
}
